/**
 * Reducer for state.ui.warehouse.
 */
import _ from 'underscore';

import {WarehouseLogin} from 'constants/WarehouseConstants';
import {BenchlingAction} from 'redux-stores/Action';

import {WarehouseActionType} from './WarehouseActions';

export interface WarehouseState {
  logins: {[loginId: string]: WarehouseLogin} | null;
}

export const WAREHOUSE_INITIAL_STATE = {
  logins: null, // null indicates loading, otherwise object of WAREHOUSE_LOGIN_SHAPE
};

function reduceLogins(
  state: {[loginId: string]: WarehouseLogin} | null = null,
  action: BenchlingAction
): {[loginId: string]: WarehouseLogin} | null {
  switch (action.type) {
    case WarehouseActionType.WAREHOUSE_LOGIN_LIST_COMPLETE:
      return _.object(action.logins.map((login) => [login.id, login]));
    case WarehouseActionType.WAREHOUSE_LOGIN_REVOKE_START: {
      const login = state![action.login.id];
      return {
        ...state,
        [login.id]: {...login, revoked: true},
      };
    }
    case WarehouseActionType.WAREHOUSE_LOGIN_REVOKE_FAIL: {
      // Rollback change
      const login = state![action.login.id];
      return {
        ...state,
        [login.id]: {...login, revoked: false},
      };
    }
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_CREATE_COMPLETE:
      return {
        ...state,
        [action.login.id]: action.login,
      };
    default:
      return state;
  }
}

export default function reduceWarehouse(
  state: WarehouseState = WAREHOUSE_INITIAL_STATE,
  action: BenchlingAction
): WarehouseState {
  switch (action.type) {
    case WarehouseActionType.WAREHOUSE_LOGIN_LIST_COMPLETE:
    case WarehouseActionType.WAREHOUSE_LOGIN_REVOKE_START:
    case WarehouseActionType.WAREHOUSE_LOGIN_REVOKE_FAIL:
    case WarehouseActionType.WAREHOUSE_CREATE_LOGIN_MODAL_CREATE_COMPLETE:
      return {
        ...state,
        logins: reduceLogins(state.logins, action),
      };
    default:
      return state;
  }
}
